import { Component, Input } from '@angular/core';
import { HidePopup } from '../../../personne.state';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-popup-capacite-error',
  templateUrl: './popup-capacite-error.component.html',
  standalone: false
})
export class PopupCapaciteErrorComponent {
  @Input()
  mode: string;

  constructor(private readonly _store: Store) {}

  close() {
    this._store.dispatch(new HidePopup());
  }
}
